import { render, staticRenderFns } from "./Alarms.vue?vue&type=template&id=8da0e91a&scoped=true&"
import script from "./Alarms.vue?vue&type=script&lang=js&"
export * from "./Alarms.vue?vue&type=script&lang=js&"
import style0 from "./Alarms.vue?vue&type=style&index=0&id=8da0e91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da0e91a",
  null
  
)

export default component.exports